import { useState } from 'react';
import { toast } from 'sonner';
import { Upload, Camera } from 'lucide-react';
import { Input } from '../ui/input';
import { errText } from '../../lib/taxBasAPI';

const ACCEPT = '.pdf,.jpg,.jpeg,.png,.heic,.xlsx,.csv,.docx';

// multi-file, drag-and-drop, mobile camera; one call per file (server dedupes identical content)
export const DocUploader = ({ upload, onDone, disabled, testId }) => {
  const [desc, setDesc] = useState('');
  const [busy, setBusy] = useState(false);
  const [over, setOver] = useState(false);
  const send = async (files) => {
    if (!files?.length) return;
    setBusy(true);
    for (const f of Array.from(files)) {
      try {
        const r = await upload(f, desc);
        toast.success(r.message || (r.duplicate ? `${f.name}: already uploaded – linked, not copied` : `${f.name} uploaded`));
      } catch (e) { toast.error(`${f.name}: ${errText(e)}`); }
    }
    setBusy(false); setDesc(''); onDone?.();
  };
  if (disabled) return null;
  return (
    <div onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); send(e.dataTransfer.files); }}
      className={`rounded-md border border-dashed p-3 text-xs transition-colors ${over ? 'border-primary bg-primary/5' : 'border-border'}`} data-testid={testId}>
      <div className="flex flex-wrap items-center gap-2">
        <label className="inline-flex cursor-pointer items-center gap-1 rounded bg-secondary px-2 py-1 hover:bg-secondary/80">
          <Upload className="h-3.5 w-3.5" />{busy ? 'Uploading…' : 'Choose files'}
          <input type="file" multiple accept={ACCEPT} className="hidden" onChange={(e) => send(e.target.files)} data-testid={`${testId}-input`} />
        </label>
        <label className="inline-flex cursor-pointer items-center gap-1 rounded bg-secondary px-2 py-1 hover:bg-secondary/80 md:hidden">
          <Camera className="h-3.5 w-3.5" />Camera
          <input type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => send(e.target.files)} />
        </label>
        <Input value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="Description (optional)" className="h-7 max-w-xs text-xs" />
        <span className="text-muted-foreground">or drop files here · PDF, JPG, PNG, XLSX, CSV, DOCX</span>
      </div>
    </div>
  );
};

export const DocList = ({ docs }) => (
  <ul className="mt-1 space-y-0.5 text-xs">
    {docs.map((d) => (
      <li key={d.id} className="text-muted-foreground" data-testid={`doc-${d.id}`}>
        <span className="text-foreground">{d.filename}</span>{d.description ? ` – ${d.description}` : ''} · {d.uploaded_by_name || 'uploaded'} · {(d.uploaded_at || '').slice(0, 16).replace('T', ' ')}
      </li>
    ))}
  </ul>
);
